/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface ShopifyDimensionMetafieldMapping
 */
export interface ShopifyDimensionMetafieldMapping {
  /**
   *
   * @type {string}
   * @memberof ShopifyDimensionMetafieldMapping
   */
  namespace: string;
  /**
   *
   * @type {string}
   * @memberof ShopifyDimensionMetafieldMapping
   */
  lengthKey?: string | null;
  /**
   *
   * @type {string}
   * @memberof ShopifyDimensionMetafieldMapping
   */
  widthKey?: string | null;
  /**
   *
   * @type {string}
   * @memberof ShopifyDimensionMetafieldMapping
   */
  heightKey?: string | null;
  /**
   *
   * @type {string}
   * @memberof ShopifyDimensionMetafieldMapping
   */
  combinedKey?: string | null;
  /**
   *
   * @type {string}
   * @memberof ShopifyDimensionMetafieldMapping
   */
  combinedOrder: string;
  /**
   *
   * @type {string}
   * @memberof ShopifyDimensionMetafieldMapping
   */
  unit?: string | null;
}

/**
 * Check if a given object implements the ShopifyDimensionMetafieldMapping interface.
 */
export function instanceOfShopifyDimensionMetafieldMapping(
  value: object,
): value is ShopifyDimensionMetafieldMapping {
  if (!("namespace" in value) || value["namespace"] === undefined) return false;
  if (!("combinedOrder" in value) || value["combinedOrder"] === undefined)
    return false;
  return true;
}

export function ShopifyDimensionMetafieldMappingFromJSON(
  json: any,
): ShopifyDimensionMetafieldMapping {
  return ShopifyDimensionMetafieldMappingFromJSONTyped(json, false);
}

export function ShopifyDimensionMetafieldMappingFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ShopifyDimensionMetafieldMapping {
  if (json == null) {
    return json;
  }
  return {
    namespace: json["namespace"],
    lengthKey: json["lengthKey"] == null ? undefined : json["lengthKey"],
    widthKey: json["widthKey"] == null ? undefined : json["widthKey"],
    heightKey: json["heightKey"] == null ? undefined : json["heightKey"],
    combinedKey: json["combinedKey"] == null ? undefined : json["combinedKey"],
    combinedOrder: json["combinedOrder"],
    unit: json["unit"] == null ? undefined : json["unit"],
  };
}

export function ShopifyDimensionMetafieldMappingToJSON(
  json: any,
): ShopifyDimensionMetafieldMapping {
  return ShopifyDimensionMetafieldMappingToJSONTyped(json, false);
}

export function ShopifyDimensionMetafieldMappingToJSONTyped(
  value?: ShopifyDimensionMetafieldMapping | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    namespace: value["namespace"],
    lengthKey: value["lengthKey"],
    widthKey: value["widthKey"],
    heightKey: value["heightKey"],
    combinedKey: value["combinedKey"],
    combinedOrder: value["combinedOrder"],
    unit: value["unit"],
  };
}
